import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form } from 'react-bootstrap';

const StyledLabel = styled.label`
    display: flex;
    flex-direction: column;
    width: fit-content;
    max-width: -webkit-fill-available;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    margin: 0.5rem 0.5rem;
    font-family: 'Inter', sans-serif;

    @media screen and (max-width: 1200px) {
        font-size: 0.9rem; /* Adjust font size for medium screens */
    }

    @media screen and (max-width: 768px) {
        font-size: 0.8rem; /* Adjust font size for small screens */
    }

    @media screen and (max-width: 480px) {
        font-size: 0.7rem; /* Adjust font size for extra small screens */
    }
`;
const SubLabel = styled.span`
    font-size: 0.75rem;
    font-weight: 600;
    font-family: 'Roboto', sans-serif;
    color: #000000;
    margin-left: 0.5rem;

    @media screen and (max-width: 1200px) {
        font-size: 0.65rem; /* Adjust sub-label font size for medium screens */
    }

    @media screen and (max-width: 768px) {
        font-size: 0.55rem; /* Adjust sub-label font size for small screens */
    }

    @media screen and (max-width: 480px) {
        font-size: 0.45rem; /* Adjust sub-label font size for extra small screens */
    }
`;

const TextLabel = ({ title, isMandatory, subLabel }) => {
    return (
        
            <Form.Label className='fw-medium col-form-label'>
                <span dangerouslySetInnerHTML={{ __html: title }} ></span>
                {isMandatory && <span className='text-danger'>*</span>}
                {subLabel && <SubLabel>({subLabel})</SubLabel>}
            </Form.Label>
            
        
    );
};
TextLabel.propTypes = {
    title: PropTypes.string.isRequired,
    isMandatory: PropTypes.bool,
    subLabel: PropTypes.string,
};
export default TextLabel;
